require('../../../modules/es.string.trim');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').trim;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/string/virtual/trim.js
// module id = 1007
// module chunks = 0